"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var sidebar_component_1 = require("./sidebar.component");
Object.defineProperty(exports, "Sidebar", { enumerable: true, get: function () { return sidebar_component_1.Sidebar; } });
//# sourceMappingURL=index.js.map